export const CognitoConstants = {
  endpoints: {
    authorize: 'oauth2/authorize',
    token: 'oauth2/token',
    logout: 'logout',
  },
  grantTypes: {
    authorizationCode: 'authorization_code',
    refreshToken: 'refresh_token',
  },
  responseType: 'code',
  scopeDelimiter: ' ',
  hostUrl: 'amazoncognito.com',
};
